import React, { useState, useEffect, useRef } from "react";
import "./ticketdashboard.css";
import Chatbox from "../components/Chat&assign/Chatbox";
import Marquee from "react-fast-marquee";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { motion } from "framer-motion";
import { FaRegUserCircle, FaSearchengin } from "react-icons/fa";

function Support() {
  const [ticketNumber, setTicketNumber] = useState("");
  const [popupvalue, setPopupvalue] = useState("");
  const [searchedTicket, setSearchedTicket] = useState("");
  const [ticketFound, setTicketFound] = useState(true);
  const statusFlow = ["Un Assigned", "Assigned", "Opened", "Hold", "Closed"];
  const getStatusIndex = (status) => {
    return statusFlow.indexOf(status);
  };

  const [supporttickets, setSupportTickets] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [messages, setMessages] = useState([]);
  const [chatMessages, setChatMessages] = useState([]);

  const [newMessage, setNewMessage] = useState("");
  const rowsPerPage = 10;
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen1, setIsOpen1] = useState(true);
  const [currentPageOpened, setCurrentPageOpened] = useState(1);
  const [currentPageClosed, setCurrentPageClosed] = useState(1);
  const openedTickets = supporttickets.filter(
    (ticket) => ticket.status !== "Closed"
  );
  const closedTickets = supporttickets.filter(
    (ticket) => ticket.status === "Closed"
  );
  const totalPagesOpened = Math.ceil(openedTickets.length / rowsPerPage);
  const startIndexOpened = (currentPageOpened - 1) * rowsPerPage;
  const currentRowsOpened = openedTickets.slice(
    startIndexOpened,
    startIndexOpened + rowsPerPage
  );

  const totalPagesClosed = Math.ceil(closedTickets.length / rowsPerPage);
  const startIndexClosed = (currentPageClosed - 1) * rowsPerPage;
  const currentRowsClosed = closedTickets.slice(
    startIndexClosed,
    startIndexClosed + rowsPerPage
  );

  const userDetails = JSON.parse(localStorage.getItem("userdetails"));

  const handleInputChange = (e) => {
    setNewMessage(e.target.value);
  };

  const handleViewClick = (row) => {
    setSelectedRow(row); // still sets the row for the modal
    setIsModalOpen(true);
    // fetchMessages(row.ticketId);
    if (row.status === "Assigned") {
      handlestatusopen(row.ticketId);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedRow(null);
    setMessages([]);
  };

  const fetchsupportTickets = async () => {
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/getsupportticket.php`;
    const formData = new FormData();

    // Append form data
    formData.append("id", userDetails.userid);
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data.message === "Records fetched successfully") {
        setSupportTickets(data.data);
      }
    } catch (error) {
      console.log("Error fetching tickets:", error);
    }
  };

  useEffect(() => {
    fetchsupportTickets();
  }, []);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
        // setaddactpopup(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // const fetchMessages = async (ticketNumber) => {
  //   try {
  //     const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/getmsg.php`;
  //     const formData = new FormData();
  //     formData.append("ticket_number", ticketNumber); // adjust based on backend param

  //     const response = await fetch(apiUrl, {
  //       method: "POST",
  //       body: formData,
  //     });

  //     const data = await response.json();

  //     if (response.ok && data.message === "Records fetched successfully") {
  //       setMessages(data.data); // Assuming backend returns message array in `data`
  //     } else {
  //       setMessages([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching messages:", error);
  //     setMessages([]);
  //   }
  // };
  const handlestatus = async (status) => {
    console.log("Ticket status changed to:", status);

    if (!selectedRow || !selectedRow.ticketId) {
      toast.error("No ticket selected.");
      return;
    }

    try {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/status.php`;
      const formData = new FormData();
      formData.append("id", selectedRow.ticketId);
      formData.append("status", status);
      formData.append("clsid", userDetails.userid);

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        toast.success(`Ticket status has been updated to ${status}`);
        fetchsupportTickets(); // refresh list
        closeModal(); // close modal
      } else {
        toast.error(data?.message || "An unexpected error occurred.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("An error occurred while updating the status.");
    }
  };

  const handlestatusopen = async (ticketId) => {
    if (!ticketId) {
      toast.error("No ticket selected.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("id", ticketId);

      const response = await fetch(
        `${process.env.REACT_APP_BASEURL}/apis/statusopen.php`,
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      if (response.ok) {
        toast.success("Ticket status has been updated to Opened");
        fetchsupportTickets(); // refresh ticket list
      } else {
        toast.error(data?.message || "An unexpected error occurred.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("An error occurred while updating the status.");
    }
  };

  const handleTicketTrack = async () => {
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/tickettrack.php`;
    const formData = new FormData();

    formData.append("user_id", userDetails?.userid);
    formData.append("ticketnumber", ticketNumber);
    formData.append("role", userDetails?.role);

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (
        response.ok &&
        result.message === "Ticketnumber tracked successfully"
      ) {
        if (Array.isArray(result.data) && result.data.length > 0) {
          setSearchedTicket(result.data[0]);
          setTicketFound(true);
        } else {
          setSearchedTicket(null);
          setTicketFound(false);
        }
      } else {
        alert("Ticket not found");
        setTicketFound(false);
      }
    } catch (error) {
      setSearchedTicket(null);
      setTicketFound(false);
    }
  };

  return (
    <div>
      {/* users name  */}
      <div className="center">
        <div className="menu-position">
          <div></div>
          <br />
          <h1 className="h1">Support Portal</h1>
          <div className="welcome_tag">
            <span>
              <div className="marquee-container">
                <Marquee
                  speed={40}
                  direction="right"
                  pauseOnHover
                  gradient={false}
                >
                  {userDetails.username}
                </Marquee>
              </div>
            </span>
            <div className="profile_icon">
              <FaRegUserCircle />
            </div>
          </div>
        </div>
      </div>

      {/* tickets cards */}
      <div className="ticket-summary">
        <div className="ticket-card">
          <span>Total Tickets:</span>
          <span>{supporttickets.length}</span>
        </div>

        <div className="ticket-card">
          <span>Assigned Tickets:</span>
          <span>
            {
              supporttickets.filter((ticket) => ticket.status === "Assigned")
                .length
            }
          </span>
        </div>

        <div className="ticket-card">
          <span>Opened Tickets:</span>
          <span>
            {
              supporttickets.filter((ticket) => ticket.status === "Opened")
                .length
            }
          </span>
        </div>

        <div className="ticket-card">
          <span>Hold Tickets:</span>
          <span>
            {supporttickets.filter((ticket) => ticket.status === "Hold").length}
          </span>
        </div>

        <div className="ticket-card">
          <span>Closed Tickets:</span>
          <span>{closedTickets.length}</span>
        </div>
      </div>

      {/* tickets track */}

      <div className="parent-container">
        <h2 className="retick">Search by Ticket Number...</h2>
        <div className="search-container">
          <input
            type="text"
            placeholder="Search by Ticket Number"
            value={ticketNumber}
            onChange={(e) => setTicketNumber(e.target.value)}
          />
          <button
            className="sebtn"
            onClick={() => (handleTicketTrack(), setPopupvalue("ticketFound"))}
          >
            <FaSearchengin />
          </button>
        </div>
      </div>

      {popupvalue === "ticketFound" &&
        Object.keys(searchedTicket).length > 0 && (
          <motion.div
            className="popup-overlay"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="ticket-details-container">
              <div className="ticket-details1">
                <div className="pop1">
                  <div className="Ticket-popup-content">
                    <h2 className="retick">Ticket Details</h2>
                    <div className="ticket-detail">
                      <span className="label1">Ticket Number: </span>
                      <span className="label1">
                        {searchedTicket?.ticketnumber}
                      </span>
                    </div>
                    <div className="ticket-detail">
                      <span className="label1">Contact Number: </span>
                      <span className="label1">
                        {searchedTicket?.contact_number}
                      </span>
                    </div>
                    <div className="ticket-detail">
                      <span className="label1">Email: </span>
                      <span className="label1">{searchedTicket?.email}</span>
                    </div>
                    <div className="ticket-detail">
                      <span className="label1">Error Title: </span>
                      <span className="label1">{searchedTicket?.e_title}</span>
                    </div>
                    <div className="ticket-detail">
                      <span className="label1">Error Description: </span>
                      <span className="label1">{searchedTicket?.e_des}</span>
                    </div>
                    <div className="ticket-detail">
                      <span className="label1">Error file: </span>

                      <span className="label1">
                        <a
                          href={`${process.env.REACT_APP_BASEURL}/apis/uploads/${searchedTicket.files}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-500 underline"
                        >
                          {searchedTicket.files}
                        </a>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="pop2">
                  <div className="status-flow-container">
                    <h2 className="retick">Ticket Status</h2>
                    {statusFlow.map((status, index) => (
                      <div
                        key={status}
                        className={`status-step ${
                          getStatusIndex(searchedTicket.status) >= index
                            ? "completed"
                            : ""
                        }`}
                      >
                        <div className="status-step-background" />
                        <div className="status-step-text">{status}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {searchedTicket && (
                <motion.div
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8 }}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "end",
                  }}
                >
                  {/* Close Button */}
                  <button
                    className="clsbtn"
                    onClick={() => {
                      setPopupvalue(false);
                      setTicketNumber("");
                    }}
                  >
                    &times;
                  </button>
                  <Chatbox
                    searchedTicketId={searchedTicket?.id}
                    status={searchedTicket?.status}
                    ticketclosed={searchedTicket?.close_time}
                    ticketclosedbyname={searchedTicket?.closedby_name}
                    // ticketassign={ticketassign}
                    // ticketclosed={ticketclosed}
                  />
                </motion.div>
              )}
            </div>
          </motion.div>
        )}

      {/* opened  */}
      <div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            onClick={() => {
              setIsOpen1(!isOpen1);
              setIsOpen(false);
            }}
            style={{
              background: "grey",
              padding: "8px 16px",
              borderRadius: "5px",
              color: "white",
              cursor: "pointer",
            }}
          >
            PENDING TICKETS
          </button>
        </div>

        <motion.div
          initial={{ height: "auto", opacity: 1 }}
          animate={{ height: isOpen1 ? "auto" : 0, opacity: isOpen1 ? 1 : 0 }}
          transition={{ duration: 0.5 }}
          style={{
            overflow: "hidden",
            background: " #f1f1f2",
            padding: isOpen1 ? "10px" : "0px",
            borderRadius: "5px",
            marginTop: "10px",
          }}
        >
          <div className="tda">
            <div className="tdb">
              <div className="tdc">
                <table border="1" className="tdd">
                  <thead className="tde">
                    <tr>
                      <th className="tdf">Serial No</th>
                      <th className="tdf">Ticket Number</th>
                      <th className="tdf">Error Tittle</th>
                      <th className="tdf">View</th>
                      <th className="tdf">Status</th>
                    </tr>
                  </thead>
                  <tbody className="tdg">
                    {currentRowsOpened.length > 0 ? (
                      currentRowsOpened.map((ticket, index) => (
                        <tr key={ticket.id}>
                          <td className="tdh">
                            {startIndexOpened + index + 1}.
                          </td>
                          <td className="tdh">{ticket.ticketnumber}</td>
                          <td className="tdh">{ticket.e_title}</td>
                          <td className="tdh">
                            <button
                              className="tdi"
                              onClick={() =>
                                handleViewClick({
                                  Email: ticket.email,
                                  ticketId: ticket.id,
                                  ticketNumber: ticket.ticketnumber,
                                  ph: ticket.contactnumber,
                                  title: ticket.e_title,
                                  errorDescription: ticket.e_des,
                                  file: ticket.files,
                                  status: ticket.status,
                                  res_tym: ticket.res_time,
                                  create: ticket.created_at,
                                })
                              }
                            >
                              View
                            </button>
                          </td>
                          <td className="tdh">{ticket.status}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="tdh" colSpan="8">
                          No tickets available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {totalPagesOpened > 1 && (
              <div className="tdj">
                <div>
                  <h2 className="tdk">
                    Page {currentPageOpened} of {totalPagesOpened}
                  </h2>

                  <div className="tdl">
                    {currentPageOpened !== 1 && (
                      <>
                        <button
                          className="tdm"
                          onClick={() => setCurrentPageOpened(1)}
                        >
                          &laquo; First page
                        </button>

                        <button
                          className="tdm"
                          onClick={() =>
                            setCurrentPageOpened((prev) =>
                              Math.max(prev - 1, 1)
                            )
                          }
                        >
                          &lt; Previous
                        </button>
                      </>
                    )}

                    {currentPageOpened !== totalPagesOpened && (
                      <>
                        <button
                          className="tdn"
                          onClick={() =>
                            setCurrentPageOpened((prev) =>
                              Math.min(prev + 1, totalPagesOpened)
                            )
                          }
                        >
                          Next &gt;
                        </button>

                        <button
                          className="tdo"
                          onClick={() => setCurrentPageOpened(totalPagesOpened)}
                        >
                          Last page &raquo;
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}

            {isModalOpen && selectedRow && (
              <div className="tdp">
                <div className="tdr">
                  <div className="tds">
                    <h2 className="tdt">Ticket Details</h2>
                    <div className="tdu">
                      <p className="tdv">
                        <strong className="tdw">Ticket Number:</strong> <br />
                        {selectedRow.ticketNumber}
                      </p>

                      <div className="ticket-time-badges">
                        <div className="time-badge">
                          <span className="time-label">Ticket Created:</span>
                          <span className="time-value">
                            {selectedRow.create}
                          </span>
                        </div>
                        <div className="time-badge">
                          {["Hold", "Opened"].includes(selectedRow?.status) && (
                            <>
                              <span className="time-label">Ticket Opened:</span>
                              <span className="time-value">
                                {selectedRow.res_tym ===
                                  "0000-00-00 00:00:00" || !selectedRow.res_tym
                                  ? "-"
                                  : selectedRow.res_tym}
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                      <p>
                        <strong className="tdw">Email:</strong> <br />
                        {selectedRow.Email}
                      </p>
                      <p>
                        <strong className="tdw">Contact Number:</strong> <br />
                        {selectedRow.ph}
                      </p>
                      <p>
                        <strong className="tdw">Error Title:</strong> <br />
                        {selectedRow.title}
                      </p>
                      <p>
                        <strong className="tdw">Error Description:</strong>{" "}
                        <br />
                        {selectedRow.errorDescription}
                      </p>
                      <p className="tdv">
                        <strong className="tdw">File:</strong> <br />
                        <a
                          href={`${process.env.REACT_APP_BASEURL}/apis/uploads/${selectedRow.file}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-500 underline"
                        >
                          {selectedRow.file}
                        </a>
                      </p>
                    </div>

                    {userDetails?.role != "cmanager" &&
                      userDetails?.role != "user" && (
                        <div className="tdx">
                          {selectedRow.status === "Hold" ? (
                            <button
                              className="tdz"
                              onClick={() => handlestatus("Closed")}
                            >
                              Closed
                            </button>
                          ) : (
                            <>
                              <button
                                className="tdy"
                                onClick={() => handlestatus("Hold")}
                              >
                                Hold
                              </button>
                              <button
                                className="tdz"
                                onClick={() => handlestatus("Closed")}
                              >
                                Closed
                              </button>
                            </>
                          )}
                        </div>
                      )}
                  </div>
                  <div>
                    <Chatbox
                      selectedRowID={selectedRow.ticketId} // OR searchedTicketId="TIC-2025-00123"
                      selectedEmail={selectedRow.Email}
                      status={selectedRow.status}
                      ticketclosed={selectedRow.closed_time}
                      ticketassign={selectedRow.asname}
                    />
                  </div>
                  <div className="tdq" onClick={closeModal}>
                    &times;
                  </div>
                </div>
              </div>
            )}
          </div>
        </motion.div>
      </div>

      {/* closed  */}
      <div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            onClick={() => {
              setIsOpen(!isOpen);
              setIsOpen1(false);
            }}
            style={{
              background: "grey",
              padding: "8px 16px",
              borderRadius: "5px",
              color: "white",
              cursor: "pointer",
            }}
            className="closed"
          >
            CLOSED TICKETS
          </button>
        </div>

        <motion.div
          initial={{ height: "auto", opacity: 1 }}
          animate={{ height: isOpen ? "auto" : 0, opacity: isOpen ? 1 : 0 }}
          transition={{ duration: 0.5 }}
          style={{
            overflow: "hidden",
            background: " #f1f1f2",
            padding: isOpen ? "10px" : "0px",
            borderRadius: "5px",
            marginTop: "10px",
          }}
        >
          <div className="tda">
            <div className="tdb">
              <div className="tdc">
                <table border="1" className="tdd">
                  <thead className="tde">
                    <tr>
                      <th className="tdf">Serial No</th>
                      <th className="tdf">Ticket Number</th>
                      <th className="tdf">Error Tittle</th>
                      <th className="tdf">View</th>
                      <th className="tdf">Status</th>
                    </tr>
                  </thead>
                  <tbody className="tdg">
                    {currentRowsClosed.length > 0 ? (
                      currentRowsClosed.map((supportticket, index) => (
                        <tr key={supportticket.id}>
                          <td className="tdh">
                            {startIndexClosed + index + 1}.
                          </td>
                          <td className="tdh">{supportticket.ticketnumber}</td>
                          <td className="tdh">{supportticket.e_title}</td>
                          <td className="tdh">
                            <button
                              className="tdi"
                              onClick={() =>
                                handleViewClick({
                                  Email: supportticket.email,
                                  ticketId: supportticket.id,
                                  ticketNumber: supportticket.ticketnumber,
                                  ph: supportticket.ph,
                                  title: supportticket.e_title,
                                  errorDescription: supportticket.e_des,
                                  file: supportticket.files,
                                  status: supportticket.status,
                                  asname: supportticket.asname,
                                  create: supportticket.created_at,
                                  res_time: supportticket.res_time,
                                  closed_time: supportticket.close_time,
                                  closed_by: supportticket.clsname,
                                })
                              }
                            >
                              View
                            </button>
                          </td>
                          <td className="tdh">{supportticket.status}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="tdh" colSpan="8">
                          No tickets available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {/* </>
              )} */}
            </div>

            {totalPagesClosed > 1 && (
              <div className="tdj">
                <div>
                  <h2 className="tdk">
                    Page {currentPageClosed} of {totalPagesClosed}
                  </h2>

                  <div className="tdl">
                    {currentPageClosed !== 1 && (
                      <>
                        <button
                          className="tdm"
                          onClick={() => setCurrentPageClosed(1)}
                        >
                          &laquo; First page
                        </button>

                        <button
                          className="tdm"
                          onClick={() =>
                            setCurrentPageClosed((prev) =>
                              Math.max(prev - 1, 1)
                            )
                          }
                        >
                          &lt; Previous
                        </button>
                      </>
                    )}

                    {currentPageClosed !== totalPagesClosed && (
                      <>
                        <button
                          className="tdn"
                          onClick={() =>
                            setCurrentPageClosed((prev) =>
                              Math.min(prev + 1, totalPagesClosed)
                            )
                          }
                        >
                          Next &gt;
                        </button>

                        <button
                          className="tdo"
                          onClick={() => setCurrentPageClosed(totalPagesClosed)}
                        >
                          Last page &raquo;
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}

            {isModalOpen && selectedRow && (
              <div className="tdp">
                <div className="tdr">
                  <div className="tds">
                    <h2 className="tdt">Ticket Details</h2>
                    <div className="tdu">
                      <p className="tdv">
                        <strong className="tdw">Ticket Number:</strong> <br />
                        {selectedRow.ticketNumber}
                      </p>
                      <div className="ticket-time-badges">
                        <div className="time-badge">
                          <span className="time-label">Ticket Created:</span>
                          <span className="time-value">
                            {selectedRow.create}
                          </span>
                        </div>
                        <div className="time-badge">
                          <span className="time-label">Ticket Opened:</span>
                          <span className="time-value">
                            {selectedRow.ticketrestym ===
                              "0000-00-00 00:00:00" || !selectedRow.res_time
                              ? "-"
                              : selectedRow.res_time}
                          </span>
                        </div>
                      </div>
                      <p>
                        <strong className="tdw">Email:</strong> <br />
                        {selectedRow.Email}
                      </p>
                      <p className="tdv">
                        <strong className="tdw">Contact Number:</strong> <br />
                        {selectedRow.ph}
                      </p>
                      <p>
                        <strong className="tdw">Error Title:</strong> <br />
                        {selectedRow.title}
                      </p>
                      <p className="tdv">
                        <strong className="tdw">Error Description:</strong>
                        <br /> {selectedRow.errorDescription}
                      </p>
                      <p className="tdv">
                        <strong className="tdw">File:</strong> <br />
                        <a
                          href={`${process.env.REACT_APP_BASEURL}/apis/uploads/${selectedRow.file}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-500 underline"
                        >
                          {selectedRow.file}
                        </a>
                      </p>
                    </div>
                  </div>

                  <Chatbox
                    selectedRowID={selectedRow.ticketId} // OR searchedTicketId="TIC-2025-00123"
                    selectedEmail={selectedRow.Email}
                    status={selectedRow.status}
                    ticketclosed={selectedRow.closed_time}
                    ticketclosedbyname={selectedRow.closed_by}
                    ticketId={selectedRow.id}
                  />
                </div>
                <div className="tdq" onClick={closeModal}>
                  &times;
                </div>
              </div>
            )}
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default Support;
